<template>
  <v-dialog v-model="dialog" scrollable max-width="500">
    <v-card>
      <v-card-title>
        ランク設定編集
        <v-spacer />
        <IconButton icon="mdi-close" @click="cancel" />
      </v-card-title>

      <v-card-text>
        <v-form ref="rank_set_form">
          <v-container>
            <v-row>
              <v-col cols="6">
                <FormInputComponent
                  label="表示順"
                  type="number"
                  v-model="showOrder"
                  rules="required"
                />
              </v-col>

              <v-col cols="12">
                <FormInputComponent
                  label="ランク設定名"
                  type="string"
                  v-model="rankSettingName"
                  rules="required"
                  :counter="10"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <FormInputComponent
                  label="評価得点開始"
                  type="number"
                  rules="required"
                  v-model="rankScoreStart"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <FormInputComponent
                  label="評価得点終了"
                  type="number"
                  rules="required"
                  v-model="rankScoreEnd"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <Button @click="erntry_confirm" color="primary">登録</Button>
              </v-col>
              <v-col v-if="!entryFlg">
                <Button @click="delete_confirm" color="danger">削除</Button>
              </v-col>
            </v-row>
            <Loader :loading="loading" />
          </v-container>
        </v-form>

        <ConfirmDialog
          ref="confirm"
          title="ランク設定編集"
          :message="confirmMessage"
          buttonMessage="OK"
          @confirm="editRankSettingInfo"
        >
        </ConfirmDialog>
        <DialogMessage ref="dialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import moment from 'moment';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem } from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    loading: false,
    dialog: false,
    confirm: false,
    entryFlg: false,
    confirmMessage: null,
    deleteFlg: false,
    resolve: null,
    reject: null,

    rankSettingId: null,
    organaizationKey: null,
    rankSettingName: null,
    rankScoreStart: 0,
    rankScoreEnd: 0,
    showOrder: 0,
    createdAt: null,
    updateAt: null,
  }),

  methods: {
    open(item) {
      this.dialog = true;
      // セレクトボックス初期化
      this.expiration = { label: '', value: '' };

      // ランク設定
      if (item == null) {
        this.entryFlg = true;
        this.rankSettingId = null;
        this.organaizationKey = null;
        this.rankSettingName = null;
        this.rankScoreStart = null;
        this.rankScoreEnd = null;
        this.showOrder = null;
        this.createdAt = null;
        this.updateAt = null;
      } else {
        this.entryFlg = false;
        this.rankSettingId = item.RANK_SETTING_ID;
        this.organaizationKey = item.ORGANIZATION_KEY;
        this.rankSettingName = item.RANK_SETTING_NAME;
        this.rankScoreStart = item.RANK_SCORE_START;
        this.rankScoreEnd = item.RANK_SCORE_END;
        this.showOrder = item.SHOW_ORDER;
        this.createdAt = item.CREATED_AT;
        this.updateAt = item.UPDATED_AT;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.rank_set_form.validate()) {
        return;
      }
      // ランク設定名(文字数)
      if (
        Buffer.byteLength(this.rankSettingName) >
        config.RANK_SETTING_NAME_MAX_LENGTH
      ) {
        this.$refs.dialog.open(
          'info',
          'ランク設定名の文字数が多いです。\n' +
            ' 入力文字数を10文字程度か、10文字より少なくしてください。'
        );
        return;
      }
      // 得点開始の小数点チェック
      var rankScoreStartArray = String(this.rankScoreStart).split('.');
      if (this.rankScoreStart != 0 && rankScoreStartArray.length != 2) {
        this.$refs.dialog.open(
          'info',
          '評価得点開始に小数点が入力されていません。\n' +
            ' 小数一桁の形式（例：99.9）で入力してください。'
        );
        return;
      }

      // 得点終了の小数点チェック
      var rankScoreEndArray = String(this.rankScoreEnd).split('.');
      if (this.rankScoreEnd != 0 && rankScoreEndArray.length != 2) {
        this.$refs.dialog.open(
          'info',
          '評価得点終了に小数点が入力されていません。\n' +
            ' 小数一桁の形式（例：99.9）で入力してください。'
        );
        return;
      }

      // 得点開始の数値範囲チェック
      if (
        Number(this.rankScoreStart) < 0 ||
        Number(this.rankScoreStart) > 100
      ) {
        this.$refs.dialog.open(
          'info',
          '評価得点開始の値が大きいです。\n' +
            ' 評価得点開始には0～100で収まる値を入力してください。'
        );
        return;
      }

      // 得点終了の数値範囲チェック
      if (Number(this.rankScoreEnd) < 0 || Number(this.rankScoreEnd) > 100) {
        this.$refs.dialog.open(
          'info',
          '評価得点終了の値が大きいです。\n' +
            ' 評価得点終了には0～100で収まる値を入力してください。'
        );
        return;
      }

      // 得点開始・終了のFROM～TOチェック
      if (Number(this.rankScoreStart) >= Number(this.rankScoreEnd)) {
        this.$refs.dialog.open(
          'info',
          '評価得点開始の値が大きいです。\n' +
            ' 評価得点開始には評価得点終了より小さい値を入力してください。'
        );
        return;
      }

      //----- ランク設定情報取得
      this.loading = true;

      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/rank/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          this.loading = false;

          // ランク設定データ範囲チェック
          var checkResult = true;
          for (var i = 0; i < response.data.length; i++) {
            if (
              this.entryFlg ||
              (!this.entryFlg &&
                this.rankSettingId != response.data[i].RANK_SETTING_ID)
            ) {
              // 新規登録、あるいは、更新で且つランク設定IDが異なるランクの場合
              var startVal = Number(response.data[i].RANK_SCORE_START);
              var endVal = Number(response.data[i].RANK_SCORE_END);
              if (
                Number(this.rankScoreStart) >= startVal &&
                Number(this.rankScoreStart) <= endVal
              ) {
                checkResult = false;
                break;
              } else if (
                Number(this.rankScoreEnd) >= startVal &&
                Number(this.rankScoreEnd) <= endVal
              ) {
                checkResult = false;
                break;
              }
            }
          }
          if (!checkResult) {
            // 評価得点の範囲NG
            this.$refs.dialog.open(
              'info',
              '評価得点開始、終了の値が別のランク設定と重複しています。\n' +
                ' 既存のランク設定と重複しない値を入力してください。'
            );
            return;
          } else {
            // 評価得点の範囲OK
            // 確認ダイアログ表示
            this.deleteFlg = false;
            this.confirmMessage =
              '[' + this.rankSettingName + ']のランク設定を登録しますか？';
            this.$refs.confirm.open();
          }
        })
        .catch((error) => {
          this.loading = false;
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    delete_confirm() {
      // 入力チェック
      if (!this.$refs.rank_set_form.validate()) {
        // チェックエラー
        return;
      }

      // 確認ダイアログ表示
      this.deleteFlg = true;
      this.confirmMessage =
        '[' + this.rankSettingName + ']のランク設定を削除しますか？';
      this.$refs.confirm.open();
    },
    editRankSettingInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.deleteFlg) {
        // 削除処理
        this.deleteRankSettingInfoRequest();
      } else {
        // 登録処理
        this.editRankSettingInfoRequest();
      }
    },
    editRankSettingInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // ユーザ情報作成
      if (this.entryFlg) {
        // 新規登録
        this.rankSettingId =
          userInfo.ORGANIZATION_KEY + moment().format('YYYYMMDDHHmmss');
        this.createdAt = moment().format('YYYYMMDDHHmmss');
      }

      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- ランク設定情報登録リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL + '/Evaluations/manages/rank/entry',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            RANK_SETTING_ID: this.rankSettingId,
            ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
            RANK_SETTING_NAME: this.rankSettingName,
            RANK_SCORE_START: this.rankScoreStart,
            RANK_SCORE_END: this.rankScoreEnd,
            SHOW_ORDER: this.showOrder,
            CREATED_AT: this.createdAt,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = message.MSG_INFO_RANK_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    deleteRankSettingInfoRequest() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();

      // 新規登録モードの場合は処理終了
      if (this.entryFlg) {
        return;
      }

      //----- ランク設定情報削除リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL + '/Evaluations/manages/rank/delete',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,
            RANK_SETTING_ID: this.rankSettingId,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = this.actEmtName + message.MSG_INFO_RANK_DELETE_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.dialog = false;
    },
  },
};
</script>
